import React, { useMemo, useState } from "react";
import { cloneDeep } from "lodash";
import { Form } from "antd";
import { calculateAutoTat } from "./utils";
import InstaCollectSettingsForm from "./InstaCollectForm";
import "./index.scss";

const InstaCollectSettings = () => {
  const [noteObj, setNoteObj] = useState({
    manualNote: "",
    autoRefundNote: "",
  });

  const createAutoCaptureNote = (values) => {
    if (values?.transaction_capture_flow_type_auto && values?.transaction_capture_attempts) {
      return (
        <p>
          Transactions can be <strong>auto captured</strong> within{" "}
          {calculateAutoTat(
            values?.transaction_capture_attempts,
            values?.transaction_capture_attempt_interval,
            values?.transaction_capture_attempt_interval_unit
          )}{" "}
          of them being created.
        </p>
      );
    } else return null;
  };

  const createManualCaptureNote = (values) => {
    if (values?.transaction_capture_flow_type_manual) {
      const manualCaptureAfter = calculateAutoTat(
        values?.transaction_capture_attempts,
        values?.transaction_capture_attempt_interval,
        values?.transaction_capture_attempt_interval_unit
      );
      return (
        <p>
          Transactions can be <strong>manually captured</strong>
          {values?.transaction_capture_flow_type_auto && manualCaptureAfter !== "---" && (
            <>
              {` after ${manualCaptureAfter} `}
              {values?.transaction_capture_tat &&
                `and before ${values?.transaction_capture_tat} ${values?.transaction_capture_tat_unit} of them being created.`}
            </>
          )}
        </p>
      );
    } else return <p>Manual Capture is disabled</p>;
  };

  const handleFormFieldChange = (props) => {
    const values = props.form.getFieldsValue();
    const updatedNoteObj = cloneDeep(noteObj);

    // --- manualNote ---
    updatedNoteObj.manualNote = (
      <>
        {createAutoCaptureNote(values)}
        {createManualCaptureNote(values)}
      </>
    );
    // --- manualNote End ---

    // --- refundAfterNote ---
    const autoRefundAfter = values?.transaction_capture_tat
      ? `${values?.transaction_capture_tat} ${values?.transaction_capture_tat_unit}`
      : "";

    updatedNoteObj.autoRefundNote = (
      <>
        Transaction Will be <b>Auto Refunded</b> after {autoRefundAfter}
      </>
    );
    // --- refundAfterNote End ---

    setNoteObj(updatedNoteObj);
  };

  const WrappedForm = useMemo(
    () =>
      Form.create({
        onFieldsChange(props) {
          handleFormFieldChange(props);
        },
      })(InstaCollectSettingsForm),
    []
  );

  return <WrappedForm noteObj={noteObj} handleFormFieldChange={handleFormFieldChange} />;
};

export default InstaCollectSettings;
